function Error() {
  return (
    <div className="error">
      🌍 Difficulty obtaining information about questions! please try again. 🌍
    </div>
  );
}

export default Error;
